import { DISCOUNT_TYPES } from '../../component/charger/charger-session/promo-code/promo-code.interface';

export const PROMO_CODE_ERROR_CODES = {
  INVALID_CODE: 'INVALID_CODE',
  NOT_APPLICABLE_TO_CHARGER: 'NOT_APPLICABLE_TO_CHARGER',
  USAGE_LIMIT_REACHED: 'USAGE_LIMIT_REACHED',
  ALREADY_APPLIED: 'ALREADY_APPLIED',
} as const;

export type PromoCodeErrorCode =
  (typeof PROMO_CODE_ERROR_CODES)[keyof typeof PROMO_CODE_ERROR_CODES];
export type DiscountType = (typeof DISCOUNT_TYPES)[keyof typeof DISCOUNT_TYPES];

export interface PromoCodeApplyPayload {
  code: string;
}

export interface AppliedDiscount {
  promoCode: string;
  discountType: DiscountType;
  discountValue: number;
  remainingUses?: number;
}

export interface PromoCodeApplyResponse {
  success?: boolean;
  appliedDiscount?: AppliedDiscount;
  promoCode?: string;
  discountType?: DiscountType;
  discountValue?: number;
  failureReason?: PromoCodeErrorCode;
  message?: string;
}
